module.exports = __webpack_public_path__ + "img/dep_butcher@3x.4ea3bc64.png";